import { css, Interpolation, ThemedStyledProps } from 'styled-components';
import { BREAKPOINTS } from './constants';

type Breakpoint = keyof typeof BREAKPOINTS;

const media: Record<Breakpoint, (arg: Interpolation<ThemedStyledProps<any, any>>) => ReturnType<typeof css>> = {
  mobile_xs: (content) => css`
    @media (max-width: ${BREAKPOINTS.mobile_xs}px) {
      ${content}
    }
  `,
  mobile_s: (content) => css`
    @media (max-width: ${BREAKPOINTS.mobile_s}px) {
      ${content}
    }
  `,
  mobile_m: (content) => css`
    @media (max-width: ${BREAKPOINTS.mobile_m}px) {
      ${content}
    }
  `,
  mobile_l: (content) => css`
    @media (max-width: ${BREAKPOINTS.mobile_l}px) {
      ${content}
    }
  `,
  mobile_xl: (content) => css`
    @media (max-width: ${BREAKPOINTS.mobile_xl}px) {
      ${content}
    }
  `,
  tablet_s: (content) => css`
    @media (max-width: ${BREAKPOINTS.tablet}px) {
      ${content}
    }
  `,
  tablet: (content) => css`
    @media (max-width: ${BREAKPOINTS.tablet}px) {
      ${content}
    }
  `,
  desktop_small: (content) => css`
    @media (max-width: ${BREAKPOINTS.desktop_small}px) {
      ${content}
    }
  `,
  desktop: (content) => css`
    @media (max-width: ${BREAKPOINTS.desktop}px) {
      ${content}
    }
  `
};

export const { mobile_xs, mobile_s, mobile_m, mobile_l, mobile_xl, tablet_s, tablet, desktop_small, desktop } = media;
